import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import profileMyBookingRequestTable from '@bookings/components/tables/profile-my-booking-request-table/profile-my-booking-request-table.vue';

@Component({
  name: 'bpc-profile-booking-requests',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bc-profile-my-booking-table': profileMyBookingRequestTable,
  },
})
export default class ProfileBookingRequests extends Vue {
  get contactId() {
    return this.$authorizationService.getContactId();
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  // COMPUTED
  get actionsPortalTarget() {
    return `activity-tax-certificate-actions-${this.$bpcHelper.generateUUIDv4()}`;
  }
}
